import React from 'react';
import CModalRFF from '../../../../Assets/Components/CModalRFF';
import { Alert } from 'antd';
import CButton from '../../../../Assets/Components/CButton';
import CIcon from '../../../../Assets/Components/CIcon';

interface IProps {
  modalIsShow: boolean;
  handleCancel: () => void;
}

export default function ModalNotifIsZelComponent(props: IProps) {
  const { modalIsShow, handleCancel } = props;
  const defaultModalstyles = {
    content: {
      position: 'relative',
      background: 'none',
      maxWidth: '95vw',
      width: '400px',
      padding: '0px',
      border: 'none',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '100px',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.75)',
      zIndex: '99',
    },
  };
  const buttonData = [
    {
      type: 'primary',
      className: 'btnCloseNotificationModal',
      onClick: handleCancel,
      content: 'Tutup',
      id: 'btnCloseNotification',
    },
  ];

  const massageAlert = () => {
    return (
      <div className="messageAlert">
        <CIcon type="InfoCircleFilled" className="contentValidation" />
        <p className="marginTop5">
          Calon agen ini <br />
          <span className="boldText">Belum lulus training!</span>
        </p>
      </div>
    );
  };

  const contentComponent = () => {
    return (
      <>
        <Alert message={massageAlert()} type="warning" />
        <p className="text-center">
          Pengajuan aktivasi agen belum dapat <br /> dilakukan, silahkan coba
          lagi nanti
        </p>
        <div className="text-center">
          <CButton buttonData={buttonData} />
        </div>
      </>
    );
  };

  return (
    <CModalRFF
      handleSubmit={() => {}}
      initialValues={[]}
      headerComponent={null}
      contentComponent={contentComponent()}
      footerComponent={null}
      modalIsShow={modalIsShow}
      handleCancel={handleCancel}
      modalstyles={defaultModalstyles}
    />
  );
}
